<template>
  <div class="list" :class="{ fixed, border }" :style="{ width: width }">
    <div class="px-5 header">
      <div class="flex-1 search" v-if="search || add">
        <input type="text" v-model="searchString" placeholder="Поиск" />
        <div class="create" v-if="add" @click="$emit('add')">+</div>
      </div>

      <slot name="header" />
    </div>

    <slot name="items" :items="filtered">
      <div class="px-5 pb-5 items">
        <div
          class="item"
          :class="{ background }"
          v-for="(item, i) in filtered"
          :key="item.id || i"
          @click="$emit('click', item, i, $event)"
        >
          <slot name="item" :item="item" />
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'uiList',
  props: {
    items: Array,
    add: Boolean,
    search: [Array, String],
    background: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '260px'
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchString: ''
    }
  },
  computed: {
    filtered () {
      if (!this.search) return this.items
      if (Array.isArray(this.search)) return this.filterByMany()
      else return this.filterByOne(this.search)
    }
  },
  methods: {
    filterByOne (search) {
      return this.items.filter(item => {
        let prop = item[search]
        if (search.includes('.')) {
          let parts = search.split('.')
          prop = item
          parts.forEach(part => {
            prop = prop[part]
          })
        }
        if (!prop) return false
        return prop.toLowerCase().includes(this.searchString.toLowerCase())
      })
    },
    filterByMany () {
      return this.items.filter(item => {
        let valid = false
        this.search.forEach(search => {
          let prop = item[search]
          if (search.includes('.')) {
            let parts = search.split('.')
            prop = item
            parts.forEach(part => {
              prop = prop[part]
            })
          }
          if (!prop) return false
          if (prop.toLowerCase().includes(this.searchString.toLowerCase()))
            return (valid = true)
        })
        return valid
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/app.less';

.list {
  height: 100%;
  overflow-y: scroll;
  flex-shrink: 0;

  &.border {
    border-right: 2px solid @grey;
  }

  &.fixed {
    height: calc(100vh - 60px);
    position: fixed;
  }

  .header {
    display: block;
    height: auto;
    position: sticky;
    top: 0;
    z-index: 5;
    background: @bg;
  }

  .search {
    background: @grey;
    display: flex;
    padding-bottom: 10px;
    background: @bg;

    input {
      width: 100%;
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
      border: none;
      margin: 0;
      padding: 0;
      background: @grey;
      text-align: center;
      outline: none;
      font-size: 15px;
    }

    .create {
      width: 40px;
      height: 40px;
      background: #000;
      color: #fff;
      border-radius: 20px;
      flex-shrink: 0;
      margin-left: 10px;
      text-align: center;
      font-size: 30px;
      line-height: 34px;
      font-weight: 600;
      cursor: pointer;
    }
  }

  .items {
    padding-bottom: 50px;

    &.padding {
      padding: 50px 0;
    }
  }

  .item {
    margin-top: 10px;
    cursor: pointer;

    &.background {
      background: @grey;
      border-radius: 10px;
      padding: 20px;
      font-size: 20px;
    }

    span {
      display: block;
      font-size: 15px;
      opacity: 0.5;
    }
  }

  .bottom {
    width: 100%;
    position: fixed;
    bottom: 0;
    padding: 0 20px;
    margin-left: -20px;
    background: @bg;
  }
}
</style>
